'use client';

import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

import Button from '@/components/Button';
import Input from '@/components/Input';
import { useProductFilters } from '@/utils/hooks/useProductFilters';

const SearchBar = () => {
  const { filters, setOffFilter, setSearchValue, clearFiltersWithoutDebounce } =
    useProductFilters();
  const [searchInputValue, setSearchInputValue] = useState('');
  const router = useRouter();

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    e.preventDefault();
    setSearchInputValue(e.currentTarget.value);
  };

  const handleKeypress = (e: any) => {
    if (e.keyCode === 13) {
      handleSearchClick();
    }
  };

  const handleSearchClick = () => {
    setOffFilter(false);
    clearFiltersWithoutDebounce();
    setSearchValue(searchInputValue);

    router.push(`/sklep?q=${searchInputValue}`);
  };

  useEffect(() => {
    setSearchInputValue(filters?.q || '');
  }, [filters]);

  return (
    <Input
      type="text"
      name="search"
      placeholder="Szukaj przedmiotów vintage"
      value={searchInputValue}
      onChange={handleChange}
      onKeyDown={handleKeypress}
      isDarkBgc
      isBorderNone
    >
      <Button isIconType onClick={handleSearchClick} ariaLabel="Szukaj">
        <MagnifyingGlassIcon />
      </Button>
    </Input>
  );
};

export default SearchBar;
